import { useState } from "react";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ranger/PageHeader";
import { Stars } from "@/components/ranger/Stars";
import { BTN_PRIMARY } from "@/pages/Servers";
import { api, errMsg } from "@/lib/api";

export const ReviewCard = ({ cid, mine, reload }) => {
  const [stars, setStars] = useState(mine?.stars || 0);
  const [comment, setComment] = useState(mine?.comment || "");
  const save = async () => {
    try { await api.post(`/player/${cid}/review`, { stars, comment }); toast.success("Thanks for your review"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Card title="Rate this server" icon={Star} testId="portal-review-card">
      <p className="mb-3 text-sm text-slate-400">Your rating shows on the public server list. You can change it any time.</p>
      <div className="flex flex-wrap items-center gap-3">
        <Stars value={stars} size="h-6 w-6" onPick={setStars} testId="portal-review-stars" />
        <Input data-testid="portal-review-comment" maxLength={300} placeholder="Optional comment" value={comment} onChange={(e) => setComment(e.target.value)} className="max-w-md flex-1 border-[#1E2D4A] bg-[#050811]" />
        <button data-testid="portal-review-submit" disabled={!stars} onClick={save} className={BTN_PRIMARY}>{mine ? "Update review" : "Submit review"}</button>
      </div>
    </Card>
  );
};
